export const FETCH_FEATURE_ACCESSIBILITY_API =
    "business/credits/accessiblility";
